// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lkfr-app .lkfr-tickets-page .business-back {
  display: none;
}
.lkfr-app .lkfr-tickets-page .business-page > h1 {
  margin: 0 0 6px;
  font-size: clamp(24px, 3vw, 30px);
}
.lkfr-app .lkfr-tickets-page .business-subtitle {
  margin: 0 0 14px;
  font-size: 13px;
  line-height: 1.4;
}
.lkfr-app .lkfr-tickets-page .tickets-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.lkfr-app .lkfr-tickets-page .tickets-actions .business-primary {
  flex: 1 1;
  min-width: 0;
  min-height: 44px;
  padding: 10px 14px;
}
.lkfr-app .lkfr-tickets-page .tickets-actions .tickets-refresh {
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  padding: 0;
}
.lkfr-app .lkfr-tickets-page .tickets-search {
  display: block;
  margin-bottom: 10px;
}
.lkfr-app .lkfr-tickets-page .tickets-search input {
  width: 100%;
  min-height: 44px;
}
.lkfr-app .lkfr-tickets-page .tickets-search-label {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
.lkfr-app .lkfr-tickets-page .tickets-filters {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  width: 100%;
  gap: 3px;
  padding: 4px;
  margin-bottom: 10px;
}
.lkfr-app .lkfr-tickets-page .tickets-filters button {
  min-height: 44px;
  min-width: 0;
  padding: 8px 3px;
  font-size: 12px;
}
.lkfr-app .lkfr-tickets-page .tickets-archive {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  margin-bottom: 10px;
  color: var(--lkfr-muted);
  font-size: 12px;
  cursor: pointer;
}
.lkfr-app .lkfr-tickets-page .tickets-archive input {
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  min-height: 0;
  padding: 0;
  margin: 0;
  accent-color: var(--lkfr-accent);
}
.lkfr-app .lkfr-tickets-page .support-tickets-list {
  gap: 10px;
}
.lkfr-app .lkfr-tickets-page .support-ticket-card {
  padding: 12px 14px;
  gap: 6px;
  border-radius: 14px;
}
.lkfr-app .lkfr-tickets-page .ticket-card-header {
  align-items: center;
  gap: 10px;
}
.lkfr-app .lkfr-tickets-page .ticket-number {
  color: var(--lkfr-muted);
  font-size: 12px;
  font-weight: 600;
}
.lkfr-app .lkfr-tickets-page .ticket-status {
  min-width: 0;
  max-width: 80%;
  padding: 4px 8px;
  font-size: 11px;
  line-height: 1.2;
}
.lkfr-app .lkfr-tickets-page .ticket-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 16px;
  line-height: 1.3;
}
.lkfr-app .lkfr-tickets-page .ticket-object {
  margin: 0;
  font-size: 12px;
  line-height: 1.3;
}
.lkfr-app .lkfr-tickets-page .ticket-urgent-flag {
  padding: 4px 7px;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 8px;
}
.lkfr-app .lkfr-tickets-page .ticket-card-dates {
  display: grid;
  gap: 2px;
  font-size: 11px;
  line-height: 1.4;
}
.lkfr-app .lkfr-tickets-page .tickets-empty {
  padding: 16px;
}
.lkfr-app .lkfr-tickets-page .tickets-empty h2 {
  margin-bottom: 8px;
  font-size: 18px;
}
.lkfr-app .lkfr-tickets-page .tickets-empty p {
  margin: 0;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/pages/shared/ticketsPage.scss"],"names":[],"mappings":"AACE;EAAiB,aAAA;AACnB;AAAE;EAAsB,eAAA;EAAiB,iCAAA;AAIzC;AAHE;EAAqB,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;AAQ1D;AANE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAQJ;AANI;EAAoB,SAAA;EAAS,YAAA;EAAc,gBAAA;EAAkB,kBAAA;AAYjE;AAXI;EAAmB,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,UAAA;AAiBlE;AAdE;EAAkB,cAAA;EAAgB,mBAAA;AAkBpC;AAjBE;EAAwB,WAAA;EAAa,gBAAA;AAqBvC;AApBE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AAsBJ;AAnBE;EACE,aAAA;EACA,gDAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;AAqBJ;AAnBI;EAAS,gBAAA;EAAkB,YAAA;EAAc,gBAAA;EAAkB,eAAA;AAyB/D;AAtBE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,eAAA;AAwBJ;AAtBI;EAAQ,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,aAAA;EAAe,UAAA;EAAY,SAAA;EAAW,gCAAA;AA+B7F;AA5BE;EAAwB,SAAA;AA+B1B;AA9BE;EAAuB,kBAAA;EAAoB,QAAA;EAAU,mBAAA;AAmCvD;AAlCE;EAAsB,mBAAA;EAAqB,SAAA;AAsC7C;AArCE;EAAiB,wBAAA;EAA0B,eAAA;EAAiB,gBAAA;AA0C9D;AAzCE;EAAiB,YAAA;EAAc,cAAA;EAAgB,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;AAgDpF;AA/CE;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAiDJ;AA/CE;EAAiB,SAAA;EAAW,eAAA;EAAiB,gBAAA;AAoD/C;AAnDE;EAAsB,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;EAAkB,kBAAA;AAyD7E;AAxDE;EAAqB,aAAA;EAAe,QAAA;EAAU,eAAA;EAAiB,gBAAA;AA8DjE;AA7DE;EAAiB,aAAA;AAgEnB;AA/DE;EAAoB,kBAAA;EAAoB,eAAA;AAmE1C;AAlEE;EAAmB,SAAA;EAAW,eAAA;AAsEhC","sourcesContent":[".lkfr-app .lkfr-tickets-page {\n  .business-back { display: none; }\n  .business-page > h1 { margin: 0 0 6px; font-size: clamp(24px, 3vw, 30px); }\n  .business-subtitle { margin: 0 0 14px; font-size: 13px; line-height: 1.4; }\n\n  .tickets-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 10px;\n\n    .business-primary { flex: 1; min-width: 0; min-height: 44px; padding: 10px 14px; }\n    .tickets-refresh { flex: 0 0 44px; width: 44px; height: 44px; padding: 0; }\n  }\n\n  .tickets-search { display: block; margin-bottom: 10px; }\n  .tickets-search input { width: 100%; min-height: 44px; }\n  .tickets-search-label {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip-path: inset(50%);\n    white-space: nowrap;\n  }\n\n  .tickets-filters {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    width: 100%;\n    gap: 3px;\n    padding: 4px;\n    margin-bottom: 10px;\n\n    button { min-height: 44px; min-width: 0; padding: 8px 3px; font-size: 12px; }\n  }\n\n  .tickets-archive {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    min-height: 44px;\n    margin-bottom: 10px;\n    color: var(--lkfr-muted);\n    font-size: 12px;\n    cursor: pointer;\n\n    input { flex: 0 0 18px; width: 18px; height: 18px; min-height: 0; padding: 0; margin: 0; accent-color: var(--lkfr-accent); }\n  }\n\n  .support-tickets-list { gap: 10px; }\n  .support-ticket-card { padding: 12px 14px; gap: 6px; border-radius: 14px; }\n  .ticket-card-header { align-items: center; gap: 10px; }\n  .ticket-number { color: var(--lkfr-muted); font-size: 12px; font-weight: 600; }\n  .ticket-status { min-width: 0; max-width: 80%; padding: 4px 8px; font-size: 11px; line-height: 1.2; }\n  .ticket-title {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    font-size: 16px;\n    line-height: 1.3;\n  }\n  .ticket-object { margin: 0; font-size: 12px; line-height: 1.3; }\n  .ticket-urgent-flag { padding: 4px 7px; font-size: 12px; line-height: 1.3; border-radius: 8px; }\n  .ticket-card-dates { display: grid; gap: 2px; font-size: 11px; line-height: 1.4; }\n  .tickets-empty { padding: 16px; }\n  .tickets-empty h2 { margin-bottom: 8px; font-size: 18px; }\n  .tickets-empty p { margin: 0; font-size: 13px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
